import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_0e9ee0e7 from 'nuxt_plugin_sentryserver_0e9ee0e7' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_ae352142 from 'nuxt_plugin_sentryclient_ae352142' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_saveChannelConfigData_c3a5cccc from 'nuxt_plugin_saveChannelConfigData_c3a5cccc' // Source: ./initChannel/boot/saveChannelConfigData.ts (mode: 'all')
import nuxt_plugin_initSettings_8845120a from 'nuxt_plugin_initSettings_8845120a' // Source: ./initChannel/boot/initSettings.ts (mode: 'all')
import nuxt_plugin_publicPathclient_75c75261 from 'nuxt_plugin_publicPathclient_75c75261' // Source: ./initChannel/boot/publicPath.client.ts (mode: 'client')
import nuxt_plugin_initChannel_12ca1b32 from 'nuxt_plugin_initChannel_12ca1b32' // Source: ./initChannel/plugins/initChannel.ts (mode: 'all')
import nuxt_plugin_nuxtuseragent_7c64cf2c from 'nuxt_plugin_nuxtuseragent_7c64cf2c' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_2bd0edcb from 'nuxt_plugin_cookieuniversalnuxt_2bd0edcb' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_router_f9f5c828 from 'nuxt_plugin_router_f9f5c828' // Source: ./router.js (mode: 'all')
import nuxt_plugin_faIcon_24bba6d5 from 'nuxt_plugin_faIcon_24bba6d5' // Source: ../src/plugins/faIcon (mode: 'all')
import nuxt_plugin_eventHandler_4d0614de from 'nuxt_plugin_eventHandler_4d0614de' // Source: ../src/plugins/eventHandler (mode: 'all')
import nuxt_plugin_instanceConnector_06dadbff from 'nuxt_plugin_instanceConnector_06dadbff' // Source: ../src/plugins/instance-connector/instanceConnector (mode: 'all')
import nuxt_plugin_i18n_259a055f from 'nuxt_plugin_i18n_259a055f' // Source: ../src/plugins/i18n (mode: 'all')
import nuxt_plugin_portalCore_3348ecac from 'nuxt_plugin_portalCore_3348ecac' // Source: ../src/plugins/portalCore (mode: 'all')
import nuxt_plugin_globalComponentsImporter_63cb3a0c from 'nuxt_plugin_globalComponentsImporter_63cb3a0c' // Source: ../src/plugins/globalComponentsImporter (mode: 'all')
import nuxt_plugin_filters_52493d16 from 'nuxt_plugin_filters_52493d16' // Source: ../src/common/filters/filters (mode: 'all')
import nuxt_plugin_analyticsTrackers_ecea9622 from 'nuxt_plugin_analyticsTrackers_ecea9622' // Source: ../src/modules/analytics/plugins/analyticsTrackers (mode: 'client')
import nuxt_plugin_piano_33beb0da from 'nuxt_plugin_piano_33beb0da' // Source: ../src/modules/piano/plugins/piano (mode: 'client')
import nuxt_plugin_portalAds_26682648 from 'nuxt_plugin_portalAds_26682648' // Source: ../src/modules/ads/plugins/portalAds (mode: 'client')
import nuxt_plugin_externalizedPackages_76a2af29 from 'nuxt_plugin_externalizedPackages_76a2af29' // Source: ../src/plugins/externalizedPackages (mode: 'client')
import nuxt_plugin_webPush_03a374a6 from 'nuxt_plugin_webPush_03a374a6' // Source: ../src/plugins/webPush (mode: 'client')
import nuxt_plugin_player_626b3fd5 from 'nuxt_plugin_player_626b3fd5' // Source: ../src/modules/podcast/plugins/player (mode: 'client')
import nuxt_plugin_alertHandler_3ad9208f from 'nuxt_plugin_alertHandler_3ad9208f' // Source: ../src/plugins/alertHandler (mode: 'client')
import nuxt_plugin_event_e4e3610e from 'nuxt_plugin_event_e4e3610e' // Source: ../src/plugins/event (mode: 'client')
import nuxt_plugin_gaa_8515bed4 from 'nuxt_plugin_gaa_8515bed4' // Source: ../src/modules/gaa/plugins/gaa (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"portal-root","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes"},{"hid":"description","name":"description","content":"Frontend for digital newspapers and magazines powered by Vue.js"}],"link":[{"href":"https:\u002F\u002Fstatic.delfi.lt\u002Fportal\u002Fcss\u002Fhotfixes.css","rel":"stylesheet"}],"script":[{"src":"https:\u002F\u002Flogs.kaya.delfi.ee\u002F683d8da10049ec077c553232.js","defer":true},{"src":"https:\u002F\u002Fstatic.delfi.lt\u002Fportal\u002Fjs\u002Fc.js","defer":true},{"src":"https:\u002F\u002Fcdn.cxense.com\u002Ftrack_banners_init.js","defer":true},{"src":"https:\u002F\u002Fstatic.delfi.lt\u002Fportal\u002Fjs\u002Fjquery.js","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_0e9ee0e7 === 'function') {
    await nuxt_plugin_sentryserver_0e9ee0e7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_ae352142 === 'function') {
    await nuxt_plugin_sentryclient_ae352142(app.context, inject)
  }

  if (typeof nuxt_plugin_saveChannelConfigData_c3a5cccc === 'function') {
    await nuxt_plugin_saveChannelConfigData_c3a5cccc(app.context, inject)
  }

  if (typeof nuxt_plugin_initSettings_8845120a === 'function') {
    await nuxt_plugin_initSettings_8845120a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_publicPathclient_75c75261 === 'function') {
    await nuxt_plugin_publicPathclient_75c75261(app.context, inject)
  }

  if (typeof nuxt_plugin_initChannel_12ca1b32 === 'function') {
    await nuxt_plugin_initChannel_12ca1b32(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_7c64cf2c === 'function') {
    await nuxt_plugin_nuxtuseragent_7c64cf2c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2bd0edcb === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2bd0edcb(app.context, inject)
  }

  if (typeof nuxt_plugin_router_f9f5c828 === 'function') {
    await nuxt_plugin_router_f9f5c828(app.context, inject)
  }

  if (typeof nuxt_plugin_faIcon_24bba6d5 === 'function') {
    await nuxt_plugin_faIcon_24bba6d5(app.context, inject)
  }

  if (typeof nuxt_plugin_eventHandler_4d0614de === 'function') {
    await nuxt_plugin_eventHandler_4d0614de(app.context, inject)
  }

  if (typeof nuxt_plugin_instanceConnector_06dadbff === 'function') {
    await nuxt_plugin_instanceConnector_06dadbff(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_259a055f === 'function') {
    await nuxt_plugin_i18n_259a055f(app.context, inject)
  }

  if (typeof nuxt_plugin_portalCore_3348ecac === 'function') {
    await nuxt_plugin_portalCore_3348ecac(app.context, inject)
  }

  if (typeof nuxt_plugin_globalComponentsImporter_63cb3a0c === 'function') {
    await nuxt_plugin_globalComponentsImporter_63cb3a0c(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_52493d16 === 'function') {
    await nuxt_plugin_filters_52493d16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analyticsTrackers_ecea9622 === 'function') {
    await nuxt_plugin_analyticsTrackers_ecea9622(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_piano_33beb0da === 'function') {
    await nuxt_plugin_piano_33beb0da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalAds_26682648 === 'function') {
    await nuxt_plugin_portalAds_26682648(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_externalizedPackages_76a2af29 === 'function') {
    await nuxt_plugin_externalizedPackages_76a2af29(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webPush_03a374a6 === 'function') {
    await nuxt_plugin_webPush_03a374a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_player_626b3fd5 === 'function') {
    await nuxt_plugin_player_626b3fd5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_alertHandler_3ad9208f === 'function') {
    await nuxt_plugin_alertHandler_3ad9208f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_event_e4e3610e === 'function') {
    await nuxt_plugin_event_e4e3610e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gaa_8515bed4 === 'function') {
    await nuxt_plugin_gaa_8515bed4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
